import DnsSettingsModal from 'modules/profile/mailing-settings/components/dns-settings-modal'
import { MailingSettingsDomainInterface } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface'
import React, { useState } from 'react'
import { EyeIcon } from '@systemeio/ui/icons'

function DnsSettingsModalWithButton({
  domainData,
}: {
  domainData: MailingSettingsDomainInterface
}) {
  const [opened, setOpened] = useState(false)

  const onClose = () => {
    setOpened(false)
  }

  return (
    <>
      <div className="cursor-pointer lg:ml-8">
        <EyeIcon onClick={() => setOpened(true)} className="hover:fill-brand-primary" />
      </div>
      <DnsSettingsModal
        domainId={domainData.id}
        dnsSettings={domainData.dnsSettings}
        opened={opened}
        onClose={onClose}
      />
    </>
  )
}

export default DnsSettingsModalWithButton
